/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationCombos200ResponseItemsInner
 */
export interface GetLocationCombos200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    organizationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    deleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    hasSchedule: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetLocationCombos200ResponseItemsInner
     */
    position: number;
}

/**
 * Check if a given object implements the GetLocationCombos200ResponseItemsInner interface.
 */
export function instanceOfGetLocationCombos200ResponseItemsInner(value: object): value is GetLocationCombos200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('organizationEnabled' in value) || value['organizationEnabled'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('hasSchedule' in value) || value['hasSchedule'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function GetLocationCombos200ResponseItemsInnerFromJSON(json: any): GetLocationCombos200ResponseItemsInner {
    return GetLocationCombos200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetLocationCombos200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationCombos200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'organizationEnabled': json['organizationEnabled'],
        'enabled': json['enabled'],
        'price': json['price'],
        'deleted': json['deleted'],
        'hasSchedule': json['hasSchedule'],
        'position': json['position'],
    };
}

export function GetLocationCombos200ResponseItemsInnerToJSON(json: any): GetLocationCombos200ResponseItemsInner {
    return GetLocationCombos200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetLocationCombos200ResponseItemsInnerToJSONTyped(value?: GetLocationCombos200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'organizationEnabled': value['organizationEnabled'],
        'enabled': value['enabled'],
        'price': value['price'],
        'deleted': value['deleted'],
        'hasSchedule': value['hasSchedule'],
        'position': value['position'],
    };
}

